import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation
      dashboard: 'Dashboard',
      news: 'News',
      products: 'Products',
      services: 'Services',
      newsCards: 'News Cards',
      serviceCards: 'Service Cards',
      
      // Common
      create: 'Create',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel',
      search: 'Search',
      actions: 'Actions',
      loading: 'Loading...',
      noData: 'No data available',
      
      // News
      newsTitle: 'News Title',
      newsTitleAr: 'News Title (Arabic)',
      newsExcerpt: 'Excerpt',
      newsExcerptAr: 'Excerpt (Arabic)',
      newsContent: 'Content',
      newsContentAr: 'Content (Arabic)',
      image: 'Image',
      publishedAt: 'Published At',
      status: 'Status',
      type: 'Type',
      
      // Products
      productTitle: 'Product Title',
      productTitleAr: 'Product Title (Arabic)',
      description: 'Description',
      descriptionAr: 'Description (Arabic)',
      features: 'Features',
      featuresAr: 'Features (Arabic)',
      useCases: 'Use Cases',
      useCasesAr: 'Use Cases (Arabic)',
      
      // Services
      serviceTitle: 'Service Title',
      serviceTitleAr: 'Service Title (Arabic)',
      subtitle: 'Subtitle',
      subtitleAr: 'Subtitle (Arabic)',
      descriptionPart1: 'Description Part 1',
      descriptionPart1Ar: 'Description Part 1 (Arabic)',
      descriptionPart2: 'Description Part 2',
      descriptionPart2Ar: 'Description Part 2 (Arabic)',
      productsTitle: 'Products Title',
      productsTitleAr: 'Products Title (Arabic)',
      serviceProducts: 'Products',
      serviceProductsAr: 'Products (Arabic)',
      icon: 'Icon',
      iconAr: 'Icon (Arabic)',
      order: 'Order',
      
      // Cards
      cardTitle: 'Card Title',
      cardTitleAr: 'Card Title (Arabic)',
      summary: 'Summary',
      summaryAr: 'Summary (Arabic)',
      cardExcerpt: 'Excerpt',
      cardExcerptAr: 'Excerpt (Arabic)',
      serviceId: 'Service ID',
      
      // Language
      language: 'Language',
      arabic: 'Arabic',
      english: 'English',
      
      // Dashboard
      totalNews: 'Total News',
      totalProducts: 'Products',
      totalServices: 'Services',
      totalViews: 'Total Views',
      contentManagement: 'Content Management',
      quickAccess: 'Quick access to manage your content across all sections',
      recentActivity: 'Recent Activity',
      latestUpdates: 'Latest updates across your content',
      quickCreate: 'Quick Create',
      createContent: 'Create new content quickly with these shortcuts',
      addNews: 'Add News',
      addProduct: 'Add Product',
      addService: 'Add Service',
      addNewsCard: 'Add News Card',
      addServiceCard: 'Add Service Card',
      manageNews: 'Manage news articles and updates',
      manageProducts: 'Manage product catalog',
      manageServices: 'Manage service offerings',
      manageNewsCards: 'Manage news card displays',
      manageServiceCards: 'Manage service card displays',
      viewAllActivity: 'View All Activity',
      welcomeBack: 'Welcome back! Here\'s what\'s happening with your content today.',
      fromLastMonth: 'from last month',
      newArticlePublished: 'New article published',
      productUpdated: 'Product updated',
      serviceAdded: 'Service added',
      newsCardCreated: 'News card created',
      techInnovationTrends: 'Tech Innovation Trends',
      smartHomeSolution: 'Smart Home Solution',
      cloudConsulting: 'Cloud Consulting',
      industryNews: 'Industry News',
      hoursAgo: 'hours ago',
      dayAgo: 'day ago',
      systemOnline: 'System Online',
    }
  },
  ar: {
    translation: {
      // Navigation
      dashboard: 'لوحة التحكم',
      news: 'الأخبار',
      products: 'المنتجات',
      services: 'الخدمات',
      newsCards: 'بطاقات الأخبار',
      serviceCards: 'بطاقات الخدمات',
      
      // Common
      create: 'إنشاء',
      edit: 'تعديل',
      delete: 'حذف',
      save: 'حفظ',
      cancel: 'إلغاء',
      search: 'بحث',
      actions: 'الإجراءات',
      loading: 'جاري التحميل...',
      noData: 'لا توجد بيانات متاحة',
      
      // News
      newsTitle: 'عنوان الخبر',
      newsTitleAr: 'عنوان الخبر (عربي)',
      newsExcerpt: 'الملخص',
      newsExcerptAr: 'الملخص (عربي)',
      newsContent: 'المحتوى',
      newsContentAr: 'المحتوى (عربي)',
      image: 'الصورة',
      publishedAt: 'تاريخ النشر',
      status: 'الحالة',
      type: 'النوع',
      
      // Products
      productTitle: 'عنوان المنتج',
      productTitleAr: 'عنوان المنتج (عربي)',
      description: 'الوصف',
      descriptionAr: 'الوصف (عربي)',
      features: 'المميزات',
      featuresAr: 'المميزات (عربي)',
      useCases: 'حالات الاستخدام',
      useCasesAr: 'حالات الاستخدام (عربي)',
      
      // Services
      serviceTitle: 'عنوان الخدمة',
      serviceTitleAr: 'عنوان الخدمة (عربي)',
      subtitle: 'العنوان الفرعي',
      subtitleAr: 'العنوان الفرعي (عربي)',
      descriptionPart1: 'الوصف الجزء الأول',
      descriptionPart1Ar: 'الوصف الجزء الأول (عربي)',
      descriptionPart2: 'الوصف الجزء الثاني',
      descriptionPart2Ar: 'الوصف الجزء الثاني (عربي)',
      productsTitle: 'عنوان المنتجات',
      productsTitleAr: 'عنوان المنتجات (عربي)',
      serviceProducts: 'المنتجات',
      serviceProductsAr: 'المنتجات (عربي)',
      icon: 'الأيقونة',
      iconAr: 'الأيقونة (عربي)',
      order: 'الترتيب',
      
      // Cards
      cardTitle: 'عنوان البطاقة',
      cardTitleAr: 'عنوان البطاقة (عربي)',
      summary: 'الملخص',
      summaryAr: 'الملخص (عربي)',
      cardExcerpt: 'المقتطف',
      cardExcerptAr: 'المقتطف (عربي)',
      serviceId: 'معرف الخدمة',
      
      // Language
      language: 'اللغة',
      arabic: 'العربية',
      english: 'الإنجليزية',
      
      // Dashboard
      totalNews: 'إجمالي الأخبار',
      totalProducts: 'المنتجات',
      totalServices: 'الخدمات',
      totalViews: 'إجمالي المشاهدات',
      contentManagement: 'إدارة المحتوى',
      quickAccess: 'وصول سريع لإدارة المحتوى عبر جميع الأقسام',
      recentActivity: 'النشاط الأخير',
      latestUpdates: 'أحدث التحديثات عبر المحتوى الخاص بك',
      quickCreate: 'إنشاء سريع',
      createContent: 'إنشاء محتوى جديد بسرعة باستخدام هذه الاختصارات',
      addNews: 'إضافة خبر',
      addProduct: 'إضافة منتج',
      addService: 'إضافة خدمة',
      addNewsCard: 'إضافة بطاقة أخبار',
      addServiceCard: 'إضافة بطاقة خدمة',
      manageNews: 'إدارة مقالات الأخبار والتحديثات',
      manageProducts: 'إدارة كتالوج المنتجات',
      manageServices: 'إدارة عروض الخدمات',
      manageNewsCards: 'إدارة عرض بطاقات الأخبار',
      manageServiceCards: 'إدارة عرض بطاقات الخدمات',
      viewAllActivity: 'عرض جميع الأنشطة',
      welcomeBack: 'مرحباً بعودتك! إليك ما يحدث مع المحتوى الخاص بك اليوم.',
      fromLastMonth: 'من الشهر الماضي',
      newArticlePublished: 'تم نشر مقال جديد',
      productUpdated: 'تم تحديث المنتج',
      serviceAdded: 'تم إضافة خدمة',
      newsCardCreated: 'تم إنشاء بطاقة أخبار',
      techInnovationTrends: 'اتجاهات الابتكار التقني',
      smartHomeSolution: 'حل المنزل الذكي',
      cloudConsulting: 'استشارات السحابة',
      industryNews: 'أخبار الصناعة',
      hoursAgo: 'ساعات مضت',
      dayAgo: 'يوم مضى',
      systemOnline: 'النظام متصل',
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ar', // Set Arabic as default language
    fallbackLng: 'ar',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

// Set initial direction based on language
const setDirection = (lng: string) => {
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
};

// Set direction on language change
i18n.on('languageChanged', setDirection);

// Set initial direction
setDirection(i18n.language);

export default i18n;
